export const EventTypes = {
    OpenTechDetails : "open:TechDetails"
}